import { createCooldownWithLock } from '@/js/autorization/timer.utils';

document.addEventListener('DOMContentLoaded', () => {
  const qs = (sel, root = document) => root.querySelector(sel);
  const qsa = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  const show = (el) => { if (el) el.style.display = ''; };
  const hide = (el) => { if (el) el.style.display = 'none'; };

  const setDisabled = (el, state) => { if (el) el.disabled = !!state; };

  const setDisabledAll = (form, state) => {
    if (!form) return;
    qsa('input, button, select, textarea', form).forEach((el) => { el.disabled = !!state; });
  };

  const getUrlParam = (name) => {
    const params = new URLSearchParams(window.location.search);
    return params.get(name);
  };

  const setInputError = (input, state) => {
    if (!input) return;
    input.classList.toggle('input--error', !!state);
  };

  const safeJsonParse = (v, fallback = {}) => {
    try { return JSON.parse(v || ''); } catch { return fallback; }
  };

  const COOLDOWN_SEC = 60;

  const RESEND_LOCK_KEY = 'register_sms_resend_locked';
  const isResendLocked = () => sessionStorage.getItem(RESEND_LOCK_KEY) === '1';
  const lockResend = () => sessionStorage.setItem(RESEND_LOCK_KEY, '1');
  const unlockResend = () => sessionStorage.removeItem(RESEND_LOCK_KEY);

  const RESEND_RECAPTCHA_ACTION = 'customer_register';

  const getRegisterDataFromSession = () => {
    const data = safeJsonParse(sessionStorage.getItem('user_register_data'), {});
    return data && typeof data === 'object' ? data : {};
  };

  const customerId = getUrlParam('customerId');

  const customerIdInput = qs('#customer_id');
  if (customerIdInput && customerId) customerIdInput.value = customerId;

  const confirmSmsPhone = qs('#confirmSmsPhone');
  if (confirmSmsPhone) {
    confirmSmsPhone.textContent = sessionStorage.getItem('user_register_phone') || '';
  }

  const timerEl = qs('#confirmSmsTimer');
  const resendBtn = qs('#resendSmsLnk'); // ✅ у HTML вже є disabled, тут початковий setDisabled не потрібен

  const cooldown = createCooldownWithLock({
    seconds: COOLDOWN_SEC,
    lockedFn: isResendLocked,
    onTick: (secLeft) => {
      if (timerEl) timerEl.textContent = `${Math.max(0, secLeft | 0)} сек`;

      // поки йде таймер або є lock — кнопка вимкнена
      if (resendBtn) setDisabled(resendBtn, secLeft > 0 || isResendLocked());
    },
    onEnable: () => {
      // cooldown закінчився -> можна вмикати тільки якщо не locked
      if (resendBtn) setDisabled(resendBtn, isResendLocked());
    },
  });

  const startCooldown = (sec = COOLDOWN_SEC) => {
    // ✅ якщо в HTML disabled — цей виклик теж не обов'язковий,
    // але лишаємо для надійності при повторному старті після resend
    setDisabled(resendBtn, true);
    cooldown.start(sec);
  };

  unlockResend();
  startCooldown(COOLDOWN_SEC);

  /* ================= resend ================= */

  const recaptchaExec = (action) =>
    new Promise((resolve, reject) => {
      if (!global.grecaptcha || !PhoneVerConf.recaptcha_key_v3) {
        reject(new Error('reCAPTCHA v3 not available'));
        return;
      }

      global.grecaptcha.ready(() => {
        global.grecaptcha
          .execute(PhoneVerConf.recaptcha_key_v3, { action })
          .then(resolve)
          .catch(reject);
      });
    });

  const onResend = async () => {
    if (!resendBtn) return;

    if (isResendLocked()) return;
    if (cooldown.getSecondsLeft() > 0) return;

    setDisabled(resendBtn, true);

    try {
      const sessionData = getRegisterDataFromSession();

      const phone =
        sessionData.phone ||
        sessionStorage.getItem('user_register_phone') ||
        '';

      const token = await recaptchaExec(RESEND_RECAPTCHA_ACTION);

      const payload = {
        ...sessionData,
        phone,
        rec_token: token,
        rec_action: RESEND_RECAPTCHA_ACTION,
      };

      const res = await fetch(PhoneVerConf.resendUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
          Accept: 'application/json',
        },
        body: JSON.stringify(payload),
      });

      const data = await res.json();

      if (data?.response) {
        lockResend();
        startCooldown(COOLDOWN_SEC);
        return;
      }

      setDisabled(resendBtn, false);
    } catch (e) {
      setDisabled(resendBtn, false);
    }
  };

  if (resendBtn) {
    resendBtn.addEventListener('click', (e) => {
      e.preventDefault();
      onResend();
    });

    // ✅ початковий setDisabled тут теж не потрібен, бо стан виставить onTick/onEnable
    // але якщо lock вже є, то на всяк випадок:
    if (isResendLocked()) setDisabled(resendBtn, true);
  }

  /* ================= form submit ================= */

  const form = qs('#phone-verification-form');
  if (!form) return;

  const codeInput = qs('#phone_verification');
  const errBlock = qs('#codeError');

  form.addEventListener('submit', async (e) => {
    e.preventDefault();

    hide(errBlock);
    setInputError(codeInput, false);

    if (!codeInput?.value) {
      window.GTM?.unsuccessfulRegistrationEvent(['phone_verification']);
      errBlock.textContent = PhoneVerConf.msg.required;
      show(errBlock);
      setInputError(codeInput, true);
      return;
    }

    setDisabledAll(form, true);

    try {
      const res = await fetch(PhoneVerConf.url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          code: codeInput.value,
          id: customerId,
        }),
      });

      const data = await res.json();

      if (data.response) {
        window.location.href = data.data.activation_url;
        return;
      }

      window.GTM?.unsuccessfulRegistrationEvent([
        'response',
        'phone_verification',
        data.code,
      ]);

      if (data.code === 500) {
        errBlock.textContent = PhoneVerConf.msg.errServer;
      } else {
        errBlock.textContent = data.message
          ? PhoneVerConf.msg.errWrongSms
          : PhoneVerConf.msg.errTryAgain;
      }

      show(errBlock);
      setInputError(codeInput, true);
    } catch (err) {
      window.GTM?.unsuccessfulRegistrationEvent(['request', 'phone_verification']);
      errBlock.textContent = PhoneVerConf.msg.errTryAgain;
      show(errBlock);
      setInputError(codeInput, true);
    } finally {
      setDisabledAll(form, false);
    }
  });
});
